import React from 'react'
import "./error401.scss";

const Error401 = (props:any) => {
  const { errorMessage } = props;

  return (
    <section id="error401" >
      <div className='all'>
        <p className='oops py-4'> OPPS!  {errorMessage}  </p>
        <span className='center-1f'>4</span>
        <span className='center-0'>0</span>
        <span className='center-lf'>1</span>
        <p className='sorry'>WE ARE SOORY, {errorMessage}</p>
      </div>
    </section>

    )
}

export default Error401 